import { render, staticRenderFns } from "./EvaOfTeacher.vue?vue&type=template&id=6c5c2be5&scoped=true&"
import script from "./EvaOfTeacher.vue?vue&type=script&lang=js&"
export * from "./EvaOfTeacher.vue?vue&type=script&lang=js&"
import style0 from "./EvaOfTeacher.vue?vue&type=style&index=0&id=6c5c2be5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c2be5",
  null
  
)

export default component.exports